/**
 * Restore Probiotics — Ritual CTA
 * Hooks the "Begin met je ritueel (6 weken)" link in the timeline section
 * and turns it into an Add-to-Cart that goes straight to checkout with the
 * 6-weken Subscribe & Save selling plan.
 *
 * Scoped to product handle: restore-probiotics
 * Idempotent via data-solvey-ritual-cta-bound guard
 */
(function () {
  'use strict';

  var VARIANT_ID = 52150452617548;
  var SELLING_PLAN_ID = 690761924940; // Every 6 weeks (recommended)
  var BUTTON_SELECTOR = 'a[class^="ai-wellness-product__button-"]';
  var GUARD_ATTR = 'data-solvey-ritual-cta-bound';

  function bindButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll(BUTTON_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.hasAttribute(GUARD_ATTR)) continue;
      var text = (btn.textContent || '').trim();
      // Only bind the ritual CTA, not random other ai-wellness buttons
      if (!/ritueel|ritual/i.test(text)) continue;
      btn.setAttribute(GUARD_ATTR, '1');
      btn.addEventListener('click', handleClick);
    }
  }

  function handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    var btn = event.currentTarget;
    if (btn.getAttribute('data-solvey-busy') === '1') return;
    btn.setAttribute('data-solvey-busy', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: VARIANT_ID,
          quantity: 1,
          selling_plan: SELLING_PLAN_ID
        }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.warn('[solvey-ritual-cta]', err);
        btn.removeAttribute('data-solvey-busy');
        // Fallback: navigate to cart so user is not stuck
        window.location.href = '/cart';
      });
  }

  // Initial bind
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindButtons(document); });
  } else {
    bindButtons(document);
  }

  // Debounced MutationObserver for late-rendered DOM (Foxify section reloads, theme editor, etc.)
  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { bindButtons(document); }, 50);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
